export default __webpack_public_path__ + "static/media/fashion_designer_1.582f2bb2.jpg";